import {getView} from "../App/actions";

export function getWidth(width) {
    if (width < 576)
        return 'xs';
    if (width < 768)
        return 'sm';
    if (width < 992)
        return 'md';
    if (width < 1200)
        return 'lg';
    if (width < 1600)
        return 'xl';
    return 'xxl';
}

const actions = {
    STORE_READ_STORE_REQUEST: 'STORE_READ_STORE_REQUEST',
    STORE_READ_STORE_SUCCESS: 'STORE_READ_STORE_SUCCESS',
    STORE_READ_STORE_FAILURE: 'STORE_READ_STORE_FAILURE',

    STORE_READ_CATEGORIES_REQUEST: 'STORE_READ_CATEGORIES_REQUEST',
    STORE_READ_CATEGORIES_SUCCESS: 'STORE_READ_CATEGORIES_SUCCESS',
    STORE_READ_CATEGORIES_FAILURE: 'STORE_READ_CATEGORIES_FAILURE',

    STORE_READ_FEATURED_REQUEST: 'STORE_READ_FEATURED_REQUEST',
    STORE_READ_FEATURED_SUCCESS: 'STORE_READ_FEATURED_SUCCESS',
    STORE_READ_FEATURED_FAILURE: 'STORE_READ_FEATURED_FAILURE',

    STORE_READ_PRODUCTS_IN_CATEGORY_REQUEST: 'STORE_READ_PRODUCTS_IN_CATEGORY_REQUEST',
    STORE_READ_PRODUCTS_IN_CATEGORY_SUCCESS: 'STORE_READ_PRODUCTS_IN_CATEGORY_SUCCESS',
    STORE_READ_PRODUCTS_IN_CATEGORY_FAILURE: 'STORE_READ_PRODUCTS_IN_CATEGORY_FAILURE',

    STORE_READ_PRODUCT_DETAILS_REQUEST: 'STORE_READ_PRODUCT_DETAILS_REQUEST',
    STORE_READ_PRODUCT_DETAILS_SUCCESS: 'STORE_READ_PRODUCT_DETAILS_SUCCESS',
    STORE_READ_PRODUCT_DETAILS_FAILURE: 'STORE_READ_PRODUCT_DETAILS_FAILURE',

    STORE_UPDATE_WIDTH: 'STORE_UPDATE_WIDTH',

    STORE_ADD_ITEM_IN_CART: 'STORE_ADD_ITEM_IN_CART',
    STORE_ADD_QTY_IN_CART: 'STORE_ADD_QTY_IN_CART',
    STORE_SUBTRACT_QTY_IN_CART: 'STORE_SUBTRACT_QTY_IN_CART',
    STORE_SET_QTY_IN_CART: 'STORE_SET_QTY_IN_CART',
    STORE_SET_INSTRUCTION_IN_CART: 'STORE_SET_INSTRUCTION_IN_CART',
    STORE_REMOVE_ITEM_IN_CART: 'STORE_REMOVE_ITEM_IN_CART',
    STORE_CLEAR_CART: 'STORE_CLEAR_CART',

    STORE_SET_CUSTOMER_ORDER_INFO: 'STORE_SET_CUSTOMER_ORDER_INFO',

    STORE_READ_PRODUCT_DATA_REQUEST: 'STORE_READ_PRODUCT_DATA_REQUEST',
    STORE_READ_PRODUCT_DATA_SUCCESS: 'STORE_READ_PRODUCT_DATA_SUCCESS',
    STORE_READ_PRODUCT_DATA_FAILURE: 'STORE_READ_PRODUCT_DATA_FAILURE',

    STORE_RECALCULATE_REQUEST: 'STORE_RECALCULATE_REQUEST',
    STORE_RECALCULATE_SUCCESS: 'STORE_RECALCULATE_SUCCESS',
    STORE_RECALCULATE_FAILURE: 'STORE_RECALCULATE_FAILURE',

    STORE_PLACE_ORDER_REQUEST: 'STORE_PLACE_ORDER_REQUEST',
    STORE_PLACE_ORDER_SUCCESS: 'STORE_PLACE_ORDER_SUCCESS',
    STORE_PLACE_ORDER_FAILURE: 'STORE_PLACE_ORDER_FAILURE',
    STORE_CLEAR_PAYMENT_DATA: 'STORE_CLEAR_PAYMENT_DATA',

    STORE_GET_ORDER_DETAILS_REQUEST: 'STORE_GET_ORDER_DETAILS_REQUEST',
    STORE_GET_ORDER_DETAILS_SUCCESS: 'STORE_GET_ORDER_DETAILS_SUCCESS',
    STORE_GET_ORDER_DETAILS_FAILURE: 'STORE_GET_ORDER_DETAILS_FAILURE',

    STORE_TOGGLE_PRODUCT_DRAWER: 'TOGGLE_PRODUCT_DRAWER',
    STORE_TOGGLE_CHECKOUT_DRAWER: 'TOGGLE_CHECKOUT_DRAWER',
    STORE_TOGGLE_STORE_INFO_DRAWER: 'TOGGLE_STORE_INFO_DRAWER',
    STORE_TOGGLE_CHECKOUT_CONFIRMATION_MODAL: 'STORE_TOGGLE_CHECKOUT_CONFIRMATION_MODAL',
    STORE_CLOSE_NOTICE_MODAL: 'STORE_CLOSE_NOTICE_MODAL',

    STORE_CHANGE_CURRENT: 'STORE_CHANGE_CURRENT',

    STORE_RESET: 'STORE_RESET',

    STORE_RESET_PRODUCTS: 'STORE_RESET_PRODUCTS',

    readStore: () => ({
        type: actions.STORE_READ_STORE_REQUEST,
    }),

    updateWidth: width => ({
        type: actions.STORE_UPDATE_WIDTH,
        view: getView(width),
        gridSize: getWidth(width),
        width,
    }),

    readCategories: () => ({
        type: actions.STORE_READ_CATEGORIES_REQUEST,
    }),

    readFeatured: () => ({
        type: actions.STORE_READ_FEATURED_REQUEST,
    }),

    readProductInCategory: request => ({
        type: actions.STORE_READ_PRODUCTS_IN_CATEGORY_REQUEST,
        request: {
            category_id: request.categoryId,
            search: request.search,
            page: request.page || 1,
            page_size: request.pageSize || 10,
        },
    }),

    readProductDetail: productId => ({
        type: actions.STORE_READ_PRODUCT_DETAILS_REQUEST,
        productId,
    }),

    // Shopping Cart
    addItemToCart: (productId, qty, instruction = '') => ({
        type: actions.STORE_ADD_ITEM_IN_CART,
        productId,
        qty,
        instruction,
    }),
    addItemQty: (productId, addQty, instruction = '') => ({
        type: actions.STORE_ADD_QTY_IN_CART,
        productId,
        addQty,
        instruction,
    }),
    subtractItemQty: (productId, subtractQty, instruction = '') => ({
        type: actions.STORE_SUBTRACT_QTY_IN_CART,
        productId,
        subtractQty,
        instruction,
    }),
    setItemQty: (productId, setQty) => ({
        type: actions.STORE_SET_QTY_IN_CART,
        productId,
        setQty,
    }),
    setItemInstruction: (productId, instruction) => ({
        type: actions.STORE_SET_INSTRUCTION_IN_CART,
        productId,
        instruction,
    }),
    removeItemFromCart: productId => ({
        type: actions.STORE_REMOVE_ITEM_IN_CART,
        productId,
    }),
    clearCart: () => ({
        type: actions.STORE_CLEAR_CART,
    }),

    setCustomerOrderInfo: request => ({
        type: actions.STORE_SET_CUSTOMER_ORDER_INFO,
        customerOrder: {
            customerName: request.customerName,
            customerMobile: request.customerMobile,
            customerEmail: request.customerEmail,
            instruction: request.instruction,
            deliveryStreet: request.deliveryStreet,
            deliveryCity: request.deliveryCity,
            deliveryState: request.deliveryState,
            deliveryPostcode: request.deliveryPostcode,
            deliveryCountryCode: request.deliveryCountryCode,
        },
    }),

    closeNoticeModal: () => ({
        type: actions.STORE_CLOSE_NOTICE_MODAL,
    }),

    placeOrder: () => ({
        type: actions.STORE_PLACE_ORDER_REQUEST,
    }),

    getOrderDetails: key => ({
        type: actions.STORE_GET_ORDER_DETAILS_REQUEST,
        key,
    }),

    recalculate: (overwrite = true) => ({
        type: actions.STORE_RECALCULATE_REQUEST,
        overwrite,
    }),

    readPrices: productIds => ({
        type: actions.STORE_READ_PRODUCT_DATA_REQUEST,
        productIds,
    }),

    clearPaymentData: () => ({
        type: actions.STORE_CLEAR_PAYMENT_DATA,
    }),

    toggleProductDrawer: value => ({
        type: actions.STORE_TOGGLE_PRODUCT_DRAWER,
        value,
    }),
    toggleCheckoutDrawer: value => ({
        type: actions.STORE_TOGGLE_CHECKOUT_DRAWER,
        value,
    }),
    toggleStoreInfoDrawer: value => ({
        type: actions.STORE_TOGGLE_STORE_INFO_DRAWER,
        value,
    }),
    toggleCheckoutConfirmationModal: value => ({
        type: actions.STORE_TOGGLE_CHECKOUT_CONFIRMATION_MODAL,
        value,
    }),
    changeCurrent: value => ({
        type: actions.STORE_CHANGE_CURRENT,
        value,
    }),

    // Reset
    resetAll: () => ({
        type: actions.STORE_RESET,
    }),

    resetProducts: () => ({
        type: actions.STORE_RESET_PRODUCTS,
    }),
};
export default actions;
